<div class="detailsListItem">
  <img id="{{ id }}" class="icon" alt="{{ name }}" [src]="icon.svg" />
  <mat-label class="iconName">{{ icon.name }}</mat-label>
</div>
